import React, { useState } from "react";
import { shallowEqual } from "react-redux";
import * as Button from "../../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Flex from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as Type from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import * as ServicePlanTagStyles from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/ServicePlanTag";
import * as BasketItemsStyles from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/basket/BasketItems";
import Price from "../../price/Price";
import * as Styles from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/basket/Basket";
import Icon from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import {
    IconWrapper,
    ToggleIconWrapper,
} from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../../../redux/store";
import { BnbLabel } from "../../../../../utils/labels";
import { removeServiceProduct } from "../../../../../redux/actions/BasketActions";
import BasketFinancePacks from "./BasketFinancePacks";
import {
    getSelectedFinancePacksEquipmentSelectorTotal,
    getTotalServicePriceSelector,
} from "../../../../../utils/selectorUtils";
import { find } from "../../../../../../../../common-deprecated/utils";
import { trackBasketRemoveExtra } from "../../../../../utils/tracking";
import { useUniqueId } from "../../../../../../../../common-deprecated/hooks";
import type { FinancePackConfigurablesType } from "../../../../../../../shared-logic/types/FinanceTypes";
import { useDispatch } from "../../../../../../../../shared-logic/redux/store";

const BasketServices = (): JSX.Element | null => {
    const uniqueId = useUniqueId();
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const serviceProducts = useBnbSelector((state) => state.basket.serviceProducts);
    const financePackServiceProducts = useBnbSelector((state) =>
        state.items.financePacks.reduce((packServiceProducts, pack) => {
            return [...packServiceProducts, ...pack.serviceProducts];
        }, [] as FinancePackConfigurablesType[]),
    );
    const financeOption = useBnbSelector((state) => state.utils.financeOption);
    const totalPrice = useBnbSelector(getTotalServicePriceSelector, shallowEqual);
    const totalFinancePackEquipment = useBnbSelector(getSelectedFinancePacksEquipmentSelectorTotal, shallowEqual);
    const financePacks = useBnbSelector((state) => state.basket.financePacks);
    const step = useBnbSelector((state) => state.navigation.step);

    const [isOpen, setIsOpen] = useState<boolean>(false);
    const exclFinancePackServiceProducts = serviceProducts.filter((sp) => !find(sp.id, financePackServiceProducts));
    // Add total of the finance pack equipment which is selected
    // + the service products selected (excluding the ones already selected through the finance pack equipment)
    // + the basket finance packs which are only added to the basket if monthly is selected
    const productCounter = totalFinancePackEquipment + exclFinancePackServiceProducts.length + financePacks.length;

    if (!serviceProducts.length && !productCounter) return null;

    return (
        <>
            <BasketItemsStyles.HeaderToggle
                isCollapsible
                onClick={() => {
                    setIsOpen(!isOpen);
                }}
                id={`${uniqueId}-header`}
                aria-expanded={isOpen}
                aria-controls={uniqueId}
            >
                <BasketItemsStyles.HeaderToggleInner isOpen={isOpen}>
                    <ToggleIconWrapper isDown={!isOpen}>
                        <Icon variant="chevronUp" />
                    </ToggleIconWrapper>
                    <BasketItemsStyles.HeaderToggleTitle>
                        <Type.SmallHeading>
                            <BnbLabel label="basketServicePlans" />
                        </Type.SmallHeading>
                        <BasketItemsStyles.Counter>{productCounter}</BasketItemsStyles.Counter>
                    </BasketItemsStyles.HeaderToggleTitle>
                    <Price price={totalPrice} />
                </BasketItemsStyles.HeaderToggleInner>
            </BasketItemsStyles.HeaderToggle>
            {isOpen && (
                <BasketItemsStyles.ContentWrapper id={uniqueId} aria-labelledby={`${uniqueId}-header`}>
                    {exclFinancePackServiceProducts.map((serviceProduct) => (
                        <Styles.ServicePlanListItem key={serviceProduct.shortId}>
                            <Flex.Row justifyContent="space-between" flexWrap="nowrap">
                                <Styles.ServicePlanListItemTerm>
                                    {serviceProduct.name}
                                    {!serviceProduct.financeable && financeOption === "monthly" && (
                                        <ServicePlanTagStyles.Tags>
                                            <ServicePlanTagStyles.Tag>
                                                <BnbLabel label="nonFinanceableServicePlans" />
                                            </ServicePlanTagStyles.Tag>
                                        </ServicePlanTagStyles.Tags>
                                    )}
                                </Styles.ServicePlanListItemTerm>
                                <Styles.ServicePlanListItemValue>
                                    {/* If the serviceplan is not financeable, show the cash price by default */}
                                    <Price
                                        price={serviceProduct.price}
                                        financeOption={serviceProduct.financeable ? financeOption : "cash"}
                                    />
                                    <Button.Link
                                        onClick={() => {
                                            trackBasketRemoveExtra(step);
                                            dispatch(removeServiceProduct(serviceProduct, true));
                                        }}
                                    >
                                        <IconWrapper>
                                            <Icon variant="close" />
                                        </IconWrapper>
                                    </Button.Link>
                                </Styles.ServicePlanListItemValue>
                            </Flex.Row>
                        </Styles.ServicePlanListItem>
                    ))}

                    {/* Show the financePacks as well in the services */}
                    <BasketFinancePacks />
                </BasketItemsStyles.ContentWrapper>
            )}
        </>
    );
};

export default BasketServices;
